if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.hideDuplicateEmbroideryFields();
    }

    hideDuplicateEmbroideryFields() {
      const keep = this.querySelector('[data-embroidery-personalization]');
      if (!keep) return;

      this.querySelectorAll('[name="properties[Iniciales]"], [name="properties[Color]"]').forEach((el) => {
        if (keep.contains(el)) return;
        el.disabled = true;
        const wrap = el.closest('div, p, label, fieldset') || el;
        wrap.style.display = 'none';
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const embroidery = this.prepareEmbroiderySubmission();
      if (embroidery === false) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const addRequest = embroidery.initials
        ? this.addEmbroideryBundle(formData, embroidery)
        : fetch(`${routes.cart_add_url}`, config).then((response) => response.json());

      addRequest
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent('cart:error', {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (embroidery.initials) {
            return this.refreshCartSections(formData.get('id'))
              .then((freshState) => {
                this.completeCartAdd(freshState, formData);
              })
              .catch((refreshError) => {
                console.error(refreshError);
                this.completeCartAdd(response, formData);
              });
          }

          this.completeCartAdd(response, formData);
        })
        .catch((e) => {
          console.error(e);
          if (embroidery.initials) {
            this.handleErrorMessage('No se pudo añadir la personalización bordada.');
            this.error = true;
          }
        })
        .finally(() => {
          this.restoreEmbroideryFields();
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    prepareEmbroiderySubmission() {
      const wrapper = this.querySelector('[data-embroidery-personalization]');
      if (!wrapper) return {};

      const initialsInput = wrapper.querySelector('[name="properties[Iniciales]"]');
      const colorSelect = wrapper.querySelector('[name="properties[Color]"]');
      const initials = (initialsInput?.value || '').trim();
      const color = (colorSelect?.value || '').trim();

      if ((initials && !color) || (!initials && color)) {
        this.handleErrorMessage('Completa las iniciales y el color del bordado, o déjalos vacíos.');
        return false;
      }

      if (!initials && !color) {
        if (initialsInput) initialsInput.disabled = true;
        if (colorSelect) colorSelect.disabled = true;
        this.embroideryDisabledFields = [initialsInput, colorSelect].filter(Boolean);
        return {};
      }

      const surchargeId = wrapper.dataset.surchargeId || '';
      if (!surchargeId) {
        this.handleErrorMessage('No se pudo añadir la personalización bordada.');
        return false;
      }

      return {
        surchargeId,
        initials,
        color
      };
    }

    restoreEmbroideryFields() {
      (this.embroideryDisabledFields || []).forEach((field) => {
        if (field) field.disabled = false;
      });
      this.embroideryDisabledFields = [];
    }

    addEmbroideryBundle(formData, embroidery) {
      const quantity = Number(formData.get('quantity') || 1);
      const groupId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const properties = {
        Iniciales: embroidery.initials,
        Color: embroidery.color,
        _bordado_grupo: groupId
      };
      const sections = this.cart
        ? this.cart.getSectionsToRender().map((section) => section.id)
        : [];
      const body = {
        items: [
          {
            id: Number(formData.get('id')),
            quantity,
            properties
          },
          {
            id: Number(embroidery.surchargeId),
            quantity,
            properties
          }
        ]
      };

      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      return fetch(`${routes.cart_add_url}`, {
        ...fetchConfig('javascript'),
        headers: {
          ...fetchConfig('javascript').headers,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }).then((response) => response.json());
    }

    refreshCartSections(productId) {
      if (!this.cart?.getSectionsToRender) {
        return Promise.resolve({ id: productId, sections: {} });
      }

      const ids = this.cart.getSectionsToRender().map((section) => section.id).filter(Boolean);
      const root = window.Shopify?.routes?.root || '/';
      return fetch(`${root}?sections=${ids.join(',')}`)
        .then((response) => response.json())
        .then((sections) => ({
          id: Number(productId),
          sections
        }));
    }

    completeCartAdd(response, formData) {
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      document.dispatchEvent(
        new CustomEvent("variant:add", {
          detail: {
            variant: {
              id: formData.get('id')
            },
            quantity: Number(formData.get("quantity") || 1),
            formElement: this.form,
            sectionId: this.dataset.source
          }
        })
      );

      fetch(`${routes.cart_url}.js`)
        .then((stateResponse) => stateResponse.text())
        .then((state) => {
          const parsedState = JSON.parse(state)

          document.dispatchEvent(
            new CustomEvent('cart:change', {
              detail: {
                cart: parsedState,
                sectionId: this.dataset.source
              }
            })
          );
        })
        .catch((error) => {
          console.error('Error fetching cart state:', error);
        });

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
      }

      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
